import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { all_routes } from "../../feature-module/router/all_routes";
import { handleApiError } from "../api/instanceApi";
import { AxiosError } from "axios";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isMoodleUserLoading } = useAuth();
  const location = useLocation();

  try {
    const JWT = sessionStorage.getItem("wstoken");

    // Nếu đang loading, không làm gì cả
    if (isMoodleUserLoading) {
      return null;
    }

    // Nếu không có token, chuyển hướng về trang login
    if (!JWT) {
      return <Navigate to={all_routes.login} state={{ from: location }} replace />;
    }

    return <>{children}</>;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export default ProtectedRoute;
